import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { resetForm } from '../../slices/fillAddressSlice';
import { logout } from '../../slices/LoginSlice';
import { settingsOpc } from '../../utils/settingsOptions';
import { MenuTab } from './MenuTab';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { customStyles } from '../../styles';
import { iconStyle, buildSupportOPT } from '../../utils/supportOptions';
import { Divider, Link, ListItemIcon, ListItemText, Stack } from '@mui/material';
import { fullOrderReset } from '../../slices/orderSlice';
export const MobileMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [token, setValue] = useLocalStorage('login-token', null)
  const { socialNetworks } = useSelector(state => state.info)
  const supportOPT = buildSupportOPT(socialNetworks)
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (route) => {
    setAnchorEl(null);
  };
  const endSesion = () => {
    dispatch(resetForm())
    dispatch(fullOrderReset())
    dispatch(logout())
    setValue(null)
    navigate('/')
  }

  
  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <AccountCircleIcon sx={{color: customStyles.colors.main, fontSize: 30, cursor: 'pointer'}} onClick={handleClose}/>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{ width: 'auto', padding: 1, padding: 3 }}
      >

        {
          supportOPT.map(item => (
            <MenuItem component={Link} href={item.link} target="_blank">
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText>{item.label}</ListItemText>
            </MenuItem>
          ))
        }
        {/* <MenuItem label="Cerrar sesión" icon={ LogoutIcon } action={ endSesion }>
        </MenuItem> */}
        <Divider />
        <MenuItem onClick={endSesion}>
          <ListItemIcon><LogoutIcon sx={iconStyle}/></ListItemIcon>
          <ListItemText>Cerrar sesión</ListItemText>
        </MenuItem>
        </Menu>
    </div>
  );
}